import { Percent, Languages, ShieldCheck, Plane, Hotel, Car } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES } from "../data/site";

const Card = ({ children, className = "", testId }) => (
    <div
        data-testid={testId}
        className={`rounded-2xl border border-white/10 bg-charcoal p-7 sm:p-9 ${className}`}
    >
        {children}
    </div>
);

const IconBadge = ({ icon: Icon }) => (
    <div className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-gold mb-6">
        <Icon size={20} strokeWidth={1.5} />
    </div>
);

export const WhyUs = () => (
    <section id="perche" data-testid="why-us-section" className="py-24 sm:py-36">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                index="01"
                eyebrow="Perché sceglierci"
                title="La cura del sorriso, senza confini."
                testId="why-us-heading"
            />

            <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
                <Reveal className="md:col-span-2" delay={0.05}>
                    <Card testId="why-card-all-inclusive" className="h-full">
                        <IconBadge icon={Plane} />
                        <h3 className="font-display text-2xl sm:text-3xl text-white font-light">
                            Tutto incluso: volo, hotel e transfer
                        </h3>
                        <p className="mt-4 text-white/70 leading-relaxed max-w-lg">
                            Un pacchetto completo pensato per chi parte dall'Italia:
                            volo A/R, soggiorno in hotel a Valona e transfer privati
                            tra aeroporto, hotel e clinica. Tu pensi solo al sorriso.
                        </p>
                        <div className="mt-8 grid grid-cols-2 gap-4">
                            <div className="overflow-hidden rounded-xl border border-white/10 h-36 sm:h-44">
                                <img
                                    src={IMAGES.hotel}
                                    alt="Hotel incluso nel pacchetto"
                                    loading="lazy"
                                    className="w-full h-full object-cover grayscale hover:grayscale-0 hover:scale-105 transition-[filter,transform] duration-700"
                                />
                            </div>
                            <div className="overflow-hidden rounded-xl border border-white/10 h-36 sm:h-44">
                                <img
                                    src={IMAGES.transfer}
                                    alt="Transfer privato incluso"
                                    loading="lazy"
                                    className="w-full h-full object-cover grayscale hover:grayscale-0 hover:scale-105 transition-[filter,transform] duration-700"
                                />
                            </div>
                        </div>
                        <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2 text-xs uppercase tracking-[0.15em] text-white/50">
                            <span className="inline-flex items-center gap-2">
                                <Plane size={13} className="text-gold" /> Volo A/R
                            </span>
                            <span className="inline-flex items-center gap-2">
                                <Hotel size={13} className="text-gold" /> Hotel a Valona
                            </span>
                            <span className="inline-flex items-center gap-2">
                                <Car size={13} className="text-gold" /> Transfer privato
                            </span>
                        </div>
                    </Card>
                </Reveal>

                <Reveal delay={0.12}>
                    <Card testId="why-card-savings" className="h-full flex flex-col justify-between">
                        <div>
                            <IconBadge icon={Percent} />
                            <p className="font-display text-6xl sm:text-7xl font-light text-gold">
                                -70%
                            </p>
                            <h3 className="mt-4 text-xl text-white">Risparmio reale</h3>
                        </div>
                        <p className="mt-4 text-white/70 leading-relaxed text-sm">
                            Stessi materiali certificati CE, stesse tecniche: fino al
                            70% in meno rispetto ai prezzi italiani.
                        </p>
                    </Card>
                </Reveal>

                <Reveal delay={0.05}>
                    <Card testId="why-card-italian" className="h-full">
                        <IconBadge icon={Languages} />
                        <h3 className="text-xl text-white">Parliamo italiano</h3>
                        <p className="mt-3 text-white/70 leading-relaxed text-sm">
                            Dalla prima consulenza su WhatsApp al follow-up dopo il
                            rientro: sarai seguito sempre nella tua lingua.
                        </p>
                    </Card>
                </Reveal>

                <Reveal delay={0.1} className="md:col-span-2">
                    <Card testId="why-card-warranty" className="h-full sm:flex sm:items-center sm:gap-10">
                        <div>
                            <IconBadge icon={ShieldCheck} />
                            <h3 className="text-xl text-white">
                                Garanzia scritta sugli impianti
                            </h3>
                            <p className="mt-3 text-white/70 leading-relaxed max-w-md">
                                Utilizziamo solo impianti certificati CE e rilasciamo
                                una garanzia scritta con documentazione completa e piano
                                dei controlli periodici.
                            </p>
                        </div>
                        <p className="hidden sm:block font-display italic text-3xl text-white/25 border-l border-white/10 pl-10">
                            "La fiducia si costruisce con i fatti."
                        </p>
                    </Card>
                </Reveal>
            </div>
        </div>
    </section>
);
